import { jsx as _jsx } from "react/jsx-runtime";
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { RADIUS } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';
import { Box } from '@mui/material';
import { AppIcon } from '../designSystem/icons/AppIcon';
export var BadgeCircle = function () {
    return (_jsx(Box, { sx: iconContainerSx, children: _jsx(AppIcon, { iconName: "Circle", diameter: "8px", color: "Blue/500", fill: "Brand/500" }) }));
};
var iconContainerSx = {
    borderRadius: RADIUS['radius-full'],
    border: "2px solid ".concat(COLOR_TOKENS['Brand/200']),
    width: '12px',
    height: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
};
